import React, { useEffect, useState, useRef, useContext } from "react";

import { Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import { Autoplay, Navigation, FreeMode } from "swiper/modules";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import TitleWithLine from "../../components/TitleWithLine";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import SkeletonAmusementGroup from "../../components/SkeletonComponent/SkeletonAmusementGroup";
import CardTile from "../../components/CardTile";
import { isMobile } from "react-device-detect";
import ApiHome from "../../../core/api/api.home";
import ContextApp from "./../../../core/contexts/context.app";
import { Link } from "react-router-dom";
import {
  IconCancelTicket,
  IconChevronLeft,
  IconFast,
  IconSecurity,
  IconDoubleArrowLeft,
  IconSpeaker,
  IconGiftBox,
  IconMedal,
} from "../../../assets/icons";
import CardComplex from "../../components/CardComplex";
import SkeletonCardComplex from "../../components/SkeletonComponent/SkeletonCardComplex";
import mapImage from "../../../assets/images/iran-map.svg";
import enamadImage from "../../../assets/images/e-namad.png";
import getMoneyImage from "../../../assets/images/money.svg";
import suplierImage from "../../../assets/images/suplier.png";
import SelectCityModal from "../../components/Header/SelectCityModal";
// import SelectCityModalHomePage from "./Component/SelectCityModalHomePage";
import SchemaMarkup from "./Component/Schema";
// import imgTehran from "../../../assets/images/tehran.jpg";
function HomeContent() {
  /**** اطلاعات مربوط به اسلایدر اصلی ***************/
  const [loading, setLoading] = useState(true);
  const ctx = useContext(ContextApp);
  const [showModalSelectCity, setShowModalSelectCity] = useState(false);
  const [showModalSelectCityHomePage, setShowModalSelectCityHomePage] =
    useState(true);
  const [liveData, setLiveData] = useState({
    amusementGroups: [],
    maxOffAmusementServices: [],
    galleries: [],
    mostPopularAmusementServices: [],
  });
  //console.log("selectedCity=",ctx.selectedCity);
  // init flag to false
  useEffect(() => {
    window.__prerenderReady = false;
  }, []);
  useEffect(() => {
    (async () => {
      const data = await ApiHome.getInfos({ city: ctx.selectedCity.id });
      setLiveData(data);
      setLoading(false);
      // وقتی داده‌ها آماده شدند، Ready را true می‌کنیم
      window.__prerenderReady = true;
    })();
  }, []);

  const groupedData = [];
  for (let i = 0; i < liveData?.amusementGroups?.length; i += 2) {
    groupedData.push(liveData?.amusementGroups?.slice(i, i + 2));
  }
  /**** وقتی وارد این صفحه می شود اسکرول بخوره به ابتدای صفحه **********************/
  const handleClick = (value) => {};
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /****  وقتی موس روی  قسمت دسته بندی تفریحات حالت دسکتاپ قرار میگره ، اسلایدر متوقف بشه ************* */
  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };
  /**** مربوط به اسلایدرهای جدیدترین ، پرطرفدارترین ، پرتخفیف ترین ******************* */
  const newestSwiperRef = useRef(null);
  const maxOfferSwiperRef = useRef(null);
  const mostPopularSwiperRef = useRef(null);

  const [isBeginningNewestSwiper, setIsBeginningNewestSwiper] = useState(true);
  const [isEndNewestSwiper, setIsEndNewestSwiper] = useState(false);

  const [isBeginningMaxOfferSwiper, setIsBeginningMaxOfferSwiper] =
    useState(true);
  const [isEndMaxOfferSwiper, setIsEndMaxOfferSwiper] = useState(false);

  const [isBeginningMostPopular, setIsBeginningMostPopular] = useState(true);
  const [isEndMostPopular, setIsEndMostPopular] = useState(false);

  const updateNavigationStateOfNewestSwiper = (swiper) => {
    setIsBeginningNewestSwiper(swiper.isBeginning);
    setIsEndNewestSwiper(swiper.isEnd);
  };
  const updateNavigationStateOfMaxOfferSwiper = (swiper) => {
    setIsBeginningMaxOfferSwiper(swiper.isBeginning);
    setIsEndMaxOfferSwiper(swiper.isEnd);
  };

  const updateNavigationStateOfMostPopular = (swiper) => {
    setIsBeginningMostPopular(swiper.isBeginning);
    setIsEndMostPopular(swiper.isEnd);
  };

  /**************** */
  return (
    <>
      {/* {ctx.selectedCity == null && showModalSelectCityHomePage && (
        <SelectCityModalHomePage
          showModalSelectCityHomePage={showModalSelectCityHomePage}
          setShowModalSelectCityHomePage={setShowModalSelectCityHomePage}
        />
      )} */}
      {/* <Modal
        show={showModalRegisterSupplier}
        onHide={handleCloseModalRegisterSupplier}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ثبت نام تامین کنندگان</Modal.Title>
        </Modal.Header>
        <Modal.Body className="small-svg text-align-justify line-height-1">
          تامین کننده گرامی!
          <br />
          شما می توانید جهت ثبت نام در پنل تامین کنندگان و یا مشاوره با
          کارشناسان مربوطه، با شماره تماس های مجموعه تفریحان تماس بگیرید.
        </Modal.Body>
        <Modal.Footer className="border-top-0 px-0 justify-content-around">
          <div className="rounded-pill border bg-white px-1 py-1">
            <a href="tel:09193373894" class="text-muted mx-1 fw-500">
              09193373894
            </a>
            <div
              className="rounded-circle bg-success text-white d-inline-block "
              style={{ padding: "5px 7px" }}
            >
              <a href="tel:09193373894" class="">
                <IconPhone fillColor="#fff" />
              </a>
            </div>
          </div>
          <div className="rounded-pill border bg-white px-1 py-1">
            <a href="tel:09199781891" class="text-muted mx-1 fw-500">
              09199781891
            </a>
            <div
              className="rounded-circle bg-success text-white d-inline-block "
              style={{ padding: "5px 7px" }}
            >
              <a href="tel:09199781891" class="">
                <IconPhone fillColor="#fff" />
              </a>
            </div>
          </div>
        </Modal.Footer>
      </Modal> */}

           <SchemaMarkup
          />
      {isMobile ? (
        /***** حالت موبایل ******************************* */
        <Container className="pt-3 margin-bottom-page">
          {/*** اسلایدر ***************************************/}
          {loading ? (
            <SkeletonTheme>
              <Skeleton
                height={130}
                width="100%"
                style={{ borderRadius: "0.75rem" }}
              ></Skeleton>
            </SkeletonTheme>
          ) : (
            <Swiper
              dir="rtl"
              spaceBetween={5}
              slidesPerView={1}
              className="image-slider-swiper"
            >
              {liveData?.galleries
                .filter((a) => a.deviceType === 2)
                ?.map((itemImageSlider) => (
                  <SwiperSlide key={itemImageSlider.id}>
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        srcSet={
                          process.env.REACT_APP_API_URL +
                          itemImageSlider.imageUrl +
                          "?width=500"
                        }
                      />
                      <img
                        onLoad={() => {
                          setLoading(false);
                        }}
                        src={
                          process.env.REACT_APP_API_URL +
                          itemImageSlider.imageUrl +
                          "?width=500"
                        }
                        alt={itemImageSlider.imageAlt}
                        className="w-100 rounded-3"
                      />
                    </picture>
                  </SwiperSlide>
                ))}
            </Swiper>
          )}
          {/**** آیکن های اعتمادسازی *********************************/}
          <div className=" d-flex align-items-center justify-content-between mt-3 text-dark-blue blue-icons small-svg">
            <div className="text-center">
              <div className="fw-bold fs-065">
                <span className="me-1">
                  <IconCancelTicket fillColor="#3c5286" />
                </span>
                امکان کنسلی
              </div>
              <div className="fs-055 mt-1">به صورت آنلایـن و تلفنی</div>
            </div>
            <div className="text-center">
              <div className="fw-bold fs-065">
                <span className="me-1">
                  <IconFast fillColor="#3c5286" />
                </span>
                صدور آنی بلیط
              </div>
              <div className="fs-055 mt-1">بدون نیاز به چـاپ بلیط</div>
            </div>
            <div className="text-center">
              <div className="fw-bold fs-065">
                <span className="me-1">
                  <IconSecurity fillColor="#3c5286" />
                </span>
                تضمین قیمت
              </div>
              <div className="fs-055 mt-1">تفریحات با بیشترین تخفیف</div>
            </div>
          </div>
          {/*** بخش دسته بندی تفریحات ***************************************************/}
          <TitleWithLine titleText="دسته بندی تفریحات" />
          {loading ? (
            /*** نمایش پیشفرض قبل از لود شدن داده ها********************/
            <Swiper slidesPerView={3.5}>
              <SwiperSlide>
                <div>
                  <SkeletonAmusementGroup />
                </div>
                <div>
                  <SkeletonAmusementGroup />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <SkeletonAmusementGroup />
                </div>
                <div>
                  <SkeletonAmusementGroup />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <SkeletonAmusementGroup />
                </div>
                <div>
                  <SkeletonAmusementGroup />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <SkeletonAmusementGroup />
                </div>
                <div>
                  <SkeletonAmusementGroup />
                </div>
              </SwiperSlide>
            </Swiper>
          ) : (
            /*** نمایش  داده ها******************************************/
            <div className="gx-0 ">
              {/* اگر تعداد گروه ها کمتر از 7 بود به صورت اسلایدی نمایش ندهد */}
              {liveData?.amusementGroups?.length < 7 ? (
                <Row className="text-center amusement-group grid-2 gx-1 row-cols-3">
                  {liveData?.amusementGroups?.map((item) => (
                    <Col>
                      <Link
                        className="w-100 d-inline-block text-dark "
                        to={
                          ctx.selectedCity?.englishName == undefined
                            ? `/c/${item.urlName?.split(" ").join("-")}`
                            : `/c/${
                                ctx.selectedCity?.englishName
                              }/${item.urlName?.split(" ").join("-")}`
                        }
                      >
                        <div className="circle-box  mx-auto">
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              item.imageUrl +
                              "?width=102"
                            }
                            alt={item.title}
                            className="w-75 mt-2 rounded-circle"
                          />
                          <span className="mb-3 mt-1 fs-065 px-1  text-truncate-1-line ">
                            {item.title}
                          </span>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              ) : (
                <Swiper
                  slidesPerView={3.5}
                  // grid={{
                  //   rows: 2,
                  // }}
                  breakpoints={{
                    768: {
                      slidesPerView: 4.5,
                    },
                    1024: {
                      slidesPerView: 5.5,
                    },
                  }}
                  freeMode={true}
                  modules={[FreeMode]}
                  className="amusement-group-2-line"
                >
                  {groupedData?.map((group, index) => (
                    <SwiperSlide
                      key={group.id}
                      className="text-center amusement-group grid-2"
                    >
                      {group.map((item) => (
                        <div>
                          {" "}
                          <Link
                            className="w-100 d-inline-block text-dark "
                            to={
                              ctx.selectedCity?.englishName == undefined
                                ? `/c/${item.urlName?.split(" ").join("-")}`
                                : `/c/${
                                    ctx.selectedCity?.englishName
                                  }/${item.urlName?.split(" ").join("-")}`
                            }
                          >
                            <div className="circle-box  mx-auto">
                              <img
                                src={
                                  process.env.REACT_APP_API_URL +
                                  item.imageUrl +
                                  "?width=102"
                                }
                                alt={item.title}
                                className="w-75 mt-2 rounded-circle"
                              />
                              <span className="mb-3 mt-1 fs-065 px-1  text-truncate-1-line ">
                                {item.title}
                              </span>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          )}
          {/*** بخش جدیدترین تفریحات ***************************************************/}
          <TitleWithLine titleText=" جدیدترین تفریحات " />
          {loading ? (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
            </Swiper>
          ) : (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              {liveData?.newestAmusementServices?.map((item) => (
                <SwiperSlide key={item.id}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                    tafrihanSuggestion={item.tafrihanSuggestion}
                    imageLabelJson={item.imageLabelJson}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          {/*** پرتخفیف ترین تفریحات ***************************************************/}
          <TitleWithLine titleText="پرتخفیف ترین تفریحات" />
          {loading ? (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
            </Swiper>
          ) : (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              {liveData?.maxOffAmusementServices?.map((item, index) => (
                <SwiperSlide key={index}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                    tafrihanSuggestion={item.tafrihanSuggestion}
                    imageLabelJson={item.imageLabelJson}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {/*** بخش پرطرفدارترین تفریحات ***************************************************/}
          <TitleWithLine titleText=" پرطرفدارترین تفریحات " />
          {loading ? (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
            </Swiper>
          ) : (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              {liveData?.mostPopularAmusementServices?.map((item) => (
                <SwiperSlide key={item.id}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                    tafrihanSuggestion={item.tafrihanSuggestion}
                    imageLabelJson={item.imageLabelJson}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {/*** تفریحات شهر تهران ***************************************************/}
          {/* <TitleWithLine titleText="  تفریحات شهر تهران " />
          {loading ? (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonDetailsContetnt />
              </SwiperSlide>
            </Swiper>
          ) : (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <div className="image-container rounded-3">
                  <img src={imgTehran} alt="" className="responsive-image " />
                  <div className="card-cover"></div>
                  <h2 className="text-white fs-normal"> تفریحات شهر تهران </h2>
                  <div className="subTitle text-white fs-075"> مشاهده همه </div>
                </div>
              </SwiperSlide>
              {liveData?.mostPopularAmusementServices?.map((item) => (
                <SwiperSlide key={item.id}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                  />
                </SwiperSlide>
              ))}
              <SwiperSlide>
                <div className="image-container rounded-3">
                  <img src={imgTehran} alt="" className="responsive-image " />
                  <div className="card-full-cover">
                    <div> مشاهده همه</div>
                  </div>
                  <h2 className="text-white fs-normal"> تفریحات شهر تهران </h2>
                  <div className="subTitle text-white fs-075"> مشاهده همه </div> 
                </div>
              </SwiperSlide>
            </Swiper>
          )} */}
          {/*** مجموعه های گردشگری ***************************************************/}
          <TitleWithLine titleText="مجموعه های گردشگری" />
          {loading ? (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              <SwiperSlide>
                <SkeletonCardComplex />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonCardComplex />
              </SwiperSlide>
              <SwiperSlide>
                <SkeletonCardComplex />
              </SwiperSlide>
            </Swiper>
          ) : (
            <Swiper
              className="amusement-swiper"
              spaceBetween={10}
              slidesPerView={"auto"}
            >
              {liveData?.amusementComplexes?.map((amusementComplex) => (
                <SwiperSlide key={amusementComplex.id}>
                  <CardComplex
                    itemImgSrc={
                      process.env.REACT_APP_API_URL + amusementComplex.imageUrl
                    }
                    // reserveItemCount={amusementComplex?.amusementServices?.length}
                    reserveItemCount={amusementComplex.amusementServiceCount}
                    itemUrl={`/p/${amusementComplex.urlName}`}
                    itemName={amusementComplex.name}
                    itemCity={amusementComplex.amusementComplexRegions
                      ?.map((rgn) => rgn.region.name)
                      .join("، ")}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          {/****  انتخاب شهر ***************************************************/}
          <Card
            className="mt-3 rounded-3 bg-gradient-red shadow-sm text-white"
            onClick={() => {
              setShowModalSelectCity(true);
            }}
          >
            <Card.Body className="py-1">
              <Row>
                <Col xs="auto" className="pe-0 my-auto">
                  <div className="fw-500 fs-085 text-shadow">
                    شهر مورد نظرت رو انتخاب کن
                  </div>
                  <div className="fs-07 text-shadow">
                    تا تفریحات اختصاصی همون شهر رو ببینی ...
                  </div>
                </Col>
                <Col className="text-end my-auto pe-1">
                  <img src={mapImage} alt="map" style={{ width: "60px" }} />
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {showModalSelectCity && (
            <SelectCityModal
              showModalSelectCity={showModalSelectCity}
              setShowModalSelectCity={setShowModalSelectCity}
            />
          )}
          {/****  e-namad  ***************************************************/}

          <div className="h-100">
            <a
              className="h-100"
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
            >
              <Card
                className="mt-2 rounded-3  bg-light-orange shadow-sm text-brown h-100"
                style={{ lineHeight: "1.4rem" }}
              >
                <Card.Body className="py-2">
                  <Row className="aling-items-center justify-content-center h-100">
                    <Col className="pe-0 my-auto fs-08">
                      <div className="">
                        این وب سایت دارای{" "}
                        <span className="fw-bold">مجوز رسمی</span>
                      </div>
                      <div className="">
                        از{" "}
                        <span className="fw-bold">
                          سازمان میراث فرهنگی و گردشگری
                        </span>{" "}
                        و
                      </div>
                      <div>
                        <span className="fw-bold">وزارت صنعت و معدن</span> می
                        باشد.
                      </div>
                    </Col>
                    <Col xs="auto" className="text-end my-auto px-1">
                      <img
                        src={enamadImage}
                        alt="map"
                        style={{ width: "70px" }}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </a>
          </div>

          {/**** ثبت نام تامین کنندگان  ***************************************************/}
          <Link
            to="https://sup.tafrihan.com/register"
            target="_blank"
            className="d-block"
          >
            <Card
              className="mt-2 rounded-3 border-0 bg-gradient-orange shadow-sm text-black "
              style={{ lineHeight: "1.2rem" }}
            >
              <Card.Body className="py-2">
                <Row>
                  <Col className="pe-0 my-auto">
                    <div className="bg-white-transparent-8 shadow-sm title-box-rounded py-1 ps-2 pe-2 d-inline-block fw-bold mb-2 fs-08">
                      ثبت نـام تامین کنندگان
                      <IconDoubleArrowLeft fillColor="#000" />
                    </div>
                    <div className=" fs-08">
                      <div>
                        اگر شما هم دارای مجموعه گردشگری هستید می توانید هم اکنون
                        رزرو مجموعه خود را به تفریحان بسپارید.
                      </div>
                    </div>
                  </Col>
                  <Col xs="auto" className="text-end my-auto px-0">
                    <img
                      src={suplierImage}
                      alt="map"
                      style={{ width: "95px" }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Link>

          {/**** ثبت نام نمایندگان  ***************************************************/}
          <Link to="https://agent.tafrihan.com/register" target="_blank">
            <Card
              className="mt-2 rounded-3 border-0 bg-gradient-orange shadow-sm text-black "
              style={{ lineHeight: "1.2rem" }}
            >
              <Card.Body className="py-2">
                <Row>
                  <Col className="pe-0 my-auto">
                    <div className="bg-white-transparent-8 shadow-sm title-box-rounded py-1 ps-2 pe-2 d-inline-block fw-bold mb-2 fs-08">
                      ثبت نـام نـماینـدگان
                      <IconDoubleArrowLeft fillColor="#000" />
                    </div>
                    <div className=" fs-08">
                      <div>
                        فروش تفریحات و دریافت کمیسیون برای تمامی افراد حقیقی و
                        حقوقی در مجموعه تفریحان قابل انجام است.
                      </div>
                    </div>
                  </Col>
                  <Col xs="auto" className="text-end my-auto px-1">
                    <img
                      src={getMoneyImage}
                      alt="map"
                      style={{ width: "80px" }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Link>
        </Container>
      ) : (
        <>
          {/***** حالت دسکتاپ ***********************************/}
          <Container>
            {/*** اسلایدر ***************************************/}
            {loading ? (
              <SkeletonTheme className="pt-3">
                <Skeleton
                  height={400}
                  width="100%"
                  style={{ borderRadius: "0.75rem" }}
                ></Skeleton>
              </SkeletonTheme>
            ) : (
              <Swiper
                spaceBetween={10}
                slidesPerView={1}
                className="image-slider-swiper pt-3"
              >
                {liveData?.galleries
                  ?.filter((a) => a.deviceType === 1)
                  .map((itemImageSlider) => (
                    <SwiperSlide key={itemImageSlider.id}>
                      <picture>
                        <source
                          media="(min-width: 992px)"
                          srcSet={
                            process.env.REACT_APP_API_URL +
                            itemImageSlider.imageUrl
                          }
                        />
                        <img
                          onLoad={() => {
                            setLoading(false);
                          }}
                          src={
                            process.env.REACT_APP_API_URL +
                            itemImageSlider.imageUrl
                          }
                          alt={itemImageSlider.imageAlt}
                          className="w-100 rounded-3"
                        />
                      </picture>
                    </SwiperSlide>
                  ))}
              </Swiper>
            )}
            {/**** آیکن های اعتمادسازی *********************************/}
            <Row className="gx-0 mt-3 text-dark-blue blue-icons bg-light-blue rounded-3 py-2 py-lg-3 px-2">
              <Col className="pe-0 text-center d-lg-flex justify-content-center">
                <div className="fw-bold fs-normal">
                  <span className="me-1">
                    <IconCancelTicket fillColor="#3c5286" />
                  </span>
                  امکان کنسلی
                </div>
                <div className="fs-085 ps-1 ps-lg-2">
                  به صورت آنلاین و تلفنی
                </div>
              </Col>
              <Col className="pe-0  text-center d-lg-flex justify-content-center border-start border-end border-secondary-subtle">
                <div className="fw-bold fs-normal">
                  <span className="me-1">
                    <IconFast fillColor="#3c5286" />
                  </span>
                  صدور آنی بلیط
                </div>
                <div className="fs-085 ps-1 ps-lg-2">بدون نیاز به چاپ بلیط</div>
              </Col>
              <Col className="pe-0  text-center d-lg-flex justify-content-center">
                <div className="fw-bold fs-normal">
                  <span className="me-1">
                    <IconSecurity fillColor="#3c5286" />
                  </span>
                  تضمین قیمت
                </div>
                <div className="fs-085 ps-1 ps-lg-2">
                  تفریحات با بیشترین تخفیف
                </div>
              </Col>
            </Row>
            {/*** بخش دسته بندی تفریحات ***********************/}
            <Row className="gx-0 border rounded-3 position-relative mt-5">
              <h2 className="box-title fw-bold fs-101 ">دسته بندی تفریحات</h2>
              <div
                className="pt-5 px-3 posistion-relative"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {loading ? (
                  /*** نمایش پیشفرض قبل از لود شدن داده ها********************/
                  <Swiper
                    className="amusement-group-swiper"
                    spaceBetween={5}
                    slidesPerView={"auto"}
                  >
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonAmusementGroup />
                    </SwiperSlide>
                  </Swiper>
                ) : (
                  /*** نمایش  داده ها******************************************/
                  <div className="swiper-container d-flex align-items-center">
                    <div className="custom-navigation">
                      <button
                        className={`btn-no-style flipX  shadow-sm amusement-group-prev-button`}
                      >
                        <IconChevronLeft fillColor="#000" />
                      </button>
                    </div>
                    <Swiper
                      className="amusement-group-swiper"
                      spaceBetween={10}
                      slidesPerView={"auto"}
                      autoplay={{ delay: 2000, disableOnInteraction: false }}
                      modules={[Autoplay, Navigation]}
                      ref={swiperRefLocal}
                      navigation={{
                        nextEl: `.amusement-group-next-button`,
                        prevEl: `.amusement-group-prev-button`,
                      }}
                    >
                      {liveData?.amusementGroups?.map((item) => (
                        <SwiperSlide>
                          <Link
                            className="w-100 mt-3 mt-lg-1 d-inline-block"
                            to={
                              ctx.selectedCity?.englishName == undefined
                                ? `/c/${item.urlName?.split(" ").join("-")}`
                                : `/c/${
                                    ctx.selectedCity?.englishName
                                  }/${item.urlName?.split(" ").join("-")}`
                            }
                          >
                            <div
                              key={item.id}
                              className="text-center amusement-group"
                            >
                              <div className="circle-box d-flex align-items-center mx-auto">
                                <img
                                  src={
                                    process.env.REACT_APP_API_URL +
                                    item.imageUrl +
                                    "?width=112"
                                  }
                                  alt={item.title}
                                  className="w-100 p-1 "
                                />
                              </div>
                              <span className="mb-4 mt-1 mt-lg-2 text-truncate-1-line text-dark">
                                {item.title}
                              </span>
                            </div>
                          </Link>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <div className="custom-navigation">
                      <button
                        className={`btn-no-style  shadow-sm amusement-group-next-button`}
                      >
                        <IconChevronLeft fillColor="#000" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Row>
          </Container>
          {/****  جدیدترین تفریحات  ******************/}
          <Container>
            <div className="">
              <Row className=" gx-0 mt-4 rounded-3">
                <div className="py-4 d-flex">
                  <div className="d-flex justify-content-center align-items-center bg-light-blue rounded-start-4 py-4">
                    <div style={{ width: "140px" }}>
                      <h2
                        className="text-center  text-dark fs-103  font-yekan mb-4"
                        style={{ lineHeight: "30px" }}
                      >
                        جدیـدتــرین تفریحات
                      </h2>
                      <div className=" d-flex justify-content-center profile-svg">
                        <IconSpeaker fillColor="#979eb1" />
                      </div>

                      <div className=" d-flex justify-content-center mt-4">
                        <button
                          style={{
                            cursor: isBeginningNewestSwiper
                              ? "not-allowed"
                              : "pointer",
                            opacity: isBeginningNewestSwiper ? 0.5 : 1,
                          }}
                          disabled={isBeginningNewestSwiper}
                          className="btn btn-light rounded-circle border-0 px-2 py-1 flipX  rounded-start-0"
                          onClick={() => {
                            if (newestSwiperRef.current) {
                              newestSwiperRef.current.swiper.slidePrev();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                        <button
                          disabled={isEndNewestSwiper}
                          style={{
                            cursor: isEndNewestSwiper
                              ? "not-allowed"
                              : "pointer",
                            opacity: isEndNewestSwiper ? 0.5 : 1,
                          }}
                          className="btn btn-light rounded-circle border-0 px-2 py-1  rounded-start-0"
                          onClick={() => {
                            if (newestSwiperRef.current) {
                              newestSwiperRef.current.swiper.slideNext();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <Swiper
                    ref={newestSwiperRef}
                    spaceBetween={10}
                    modules={[Navigation]}
                    slidesPerView={"auto"}
                    className="amusement-swiper bg-light-blue  rounded-end-3 pe-3"
                    watchSlidesProgress={true}
                    watchOverflow={true}
                    onReachEnd={() => setIsEndNewestSwiper(true)}
                    onSlideChange={(newestSwiperRef) =>
                      updateNavigationStateOfNewestSwiper(newestSwiperRef)
                    }
                    onInit={(newestSwiperRef) =>
                      updateNavigationStateOfNewestSwiper(newestSwiperRef)
                    }
                    onResize={(newestSwiperRef) =>
                      updateNavigationStateOfNewestSwiper(newestSwiperRef)
                    }
                  >
                    {loading ? (
                      <>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                      </>
                    ) : (
                      liveData?.newestAmusementServices?.map((item) => (
                        <SwiperSlide key={item.id}>
                          <CardTile
                            itemImgSrc={
                              process.env.REACT_APP_API_URL + item.imageUrl
                            }
                            amusementUrl={`/details/${item.urlName}`}
                            amusementName={item.name}
                            amusementPrice={item.price}
                            amusementFinalPrice={item.originalPrice}
                            handleClick={handleClick}
                            tafrihanSuggestion={item.tafrihanSuggestion}
                            imageLabelJson={item.imageLabelJson}
                          />
                        </SwiperSlide>
                      ))
                    )}
                  </Swiper>
                </div>
              </Row>
            </div>
          </Container>

          {/****   پرتخفیف ترین تفریحات  ******************/}
          <Container fluid className="">
            <Container>
              <Row className=" gx-0 mt-2 rounded-3">
                <div className="py-4 d-flex">
                  <div className="d-flex justify-content-center align-items-center bg-light-blue rounded-start-4 py-4">
                    <div style={{ width: "140px" }}>
                      <h2
                        className="text-center  text-dark fs-103  font-yekan mb-4"
                        style={{ lineHeight: "30px" }}
                      >
                        پرتخفیف‌‌ترین تفریحات
                      </h2>
                      <div className="profile-svg d-flex justify-content-center">
                        <IconGiftBox fillColor="#979eb1" />
                        {/* <img
                          src={giftVector}
                          alt="newest"
                          className="w-50 opacity-25"
                        /> */}
                      </div>
                      <div className=" d-flex justify-content-center mt-4">
                        <button
                          style={{
                            cursor: isBeginningMaxOfferSwiper
                              ? "not-allowed"
                              : "pointer",
                            opacity: isBeginningMaxOfferSwiper ? 0.5 : 1,
                          }}
                          disabled={isBeginningMaxOfferSwiper}
                          className="btn btn-light rounded-circle border-0 px-2 py-1 flipX  rounded-start-0"
                          onClick={() => {
                            if (maxOfferSwiperRef.current) {
                              maxOfferSwiperRef.current.swiper.slidePrev();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                        <button
                          style={{
                            cursor: isEndMaxOfferSwiper
                              ? "not-allowed"
                              : "pointer",
                            opacity: isEndMaxOfferSwiper ? 0.5 : 1,
                          }}
                          disabled={isEndMaxOfferSwiper}
                          className="btn btn-light rounded-circle border-0 px-2 py-1  rounded-start-0"
                          onClick={() => {
                            if (maxOfferSwiperRef.current) {
                              maxOfferSwiperRef.current.swiper.slideNext();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <Swiper
                    ref={maxOfferSwiperRef}
                    spaceBetween={10}
                    modules={[Navigation]}
                    slidesPerView={"auto"}
                    className="amusement-swiper bg-light-blue rounded-end-3 pe-3"
                    watchSlidesProgress={true}
                    watchOverflow={true}
                    onReachEnd={() => setIsEndMaxOfferSwiper(true)}
                    onSlideChange={(maxOfferSwiperRef) =>
                      updateNavigationStateOfMaxOfferSwiper(maxOfferSwiperRef)
                    }
                    onInit={(maxOfferSwiperRef) =>
                      updateNavigationStateOfMaxOfferSwiper(maxOfferSwiperRef)
                    }
                    onResize={(maxOfferSwiperRef) =>
                      updateNavigationStateOfMaxOfferSwiper(maxOfferSwiperRef)
                    }
                  >
                    {loading ? (
                      <>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                      </>
                    ) : (
                      liveData?.maxOffAmusementServices?.map((item) => (
                        <SwiperSlide key={item.id}>
                          <CardTile
                            itemImgSrc={
                              process.env.REACT_APP_API_URL + item.imageUrl
                            }
                            amusementUrl={`/details/${item.urlName}`}
                            amusementName={item.name}
                            amusementPrice={item.price}
                            amusementFinalPrice={item.originalPrice}
                            handleClick={handleClick}
                            tafrihanSuggestion={item.tafrihanSuggestion}
                            imageLabelJson={item.imageLabelJson}
                          />
                        </SwiperSlide>
                      ))
                    )}
                  </Swiper>
                </div>
              </Row>
              <Container>
                <Row className=" gx-0 mt-2 rounded-3">
                  <div></div>
                </Row>
              </Container>
            </Container>
          </Container>

          {/****  پرطرفدارترین تفریحات  ******************/}
          <Container>
            <div className=" rounded-3">
              <Row className=" gx-0 mt-2 rounded-3">
                <div className="py-4 d-flex">
                  <div className="d-flex justify-content-center align-items-center bg-light-blue rounded-start-4 py-4">
                    <div style={{ width: "140px" }}>
                      <h2
                        className="text-center  text-dark fs-103  mb-4 font-yekan"
                        style={{ lineHeight: "30px" }}
                      >
                        پرطرفدارترین تفریحات
                      </h2>
                      <div className=" d-flex justify-content-center profile-svg">
                        <IconMedal fillColor="#979eb1" />
                      </div>
                      <div className=" d-flex justify-content-center mt-4">
                        <button
                          style={{
                            cursor: isBeginningMostPopular
                              ? "not-allowed"
                              : "pointer",
                            opacity: isBeginningMostPopular ? 0.5 : 1,
                          }}
                          disabled={isBeginningMostPopular}
                          className="btn btn-light rounded-circle border-0 px-2 py-1 flipX  rounded-start-0"
                          onClick={() => {
                            if (mostPopularSwiperRef.current) {
                              mostPopularSwiperRef.current.swiper.slidePrev();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                        <button
                          style={{
                            cursor: isEndMostPopular
                              ? "not-allowed"
                              : "pointer",
                            opacity: isEndMostPopular ? 0.5 : 1,
                          }}
                          disabled={isEndMostPopular}
                          className="btn btn-light rounded-circle border-0 px-2 py-1  rounded-start-0"
                          onClick={() => {
                            if (mostPopularSwiperRef.current) {
                              mostPopularSwiperRef.current.swiper.slideNext();
                            }
                          }}
                        >
                          <IconChevronLeft fillColor="#575757" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <Swiper
                    ref={mostPopularSwiperRef}
                    spaceBetween={10}
                    modules={[Navigation]}
                    slidesPerView={"auto"}
                    className="amusement-swiper bg-light-blue rounded-end-3 pe-3"
                    watchSlidesProgress={true}
                    watchOverflow={true}
                    onReachEnd={() => setIsEndMostPopular(true)}
                    onSlideChange={(mostPopularSwiperRef) =>
                      updateNavigationStateOfMostPopular(mostPopularSwiperRef)
                    }
                    onInit={(mostPopularSwiperRef) =>
                      updateNavigationStateOfMostPopular(mostPopularSwiperRef)
                    }
                    onResize={(mostPopularSwiperRef) =>
                      updateNavigationStateOfMostPopular(mostPopularSwiperRef)
                    }
                  >
                    {loading ? (
                      <>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                      </>
                    ) : (
                      liveData?.mostPopularAmusementServices?.map((item) => (
                        <SwiperSlide key={item.id}>
                          <CardTile
                            itemImgSrc={
                              process.env.REACT_APP_API_URL + item.imageUrl
                            }
                            amusementUrl={`/details/${item.urlName}`}
                            amusementName={item.name}
                            amusementPrice={item.price}
                            amusementFinalPrice={item.originalPrice}
                            handleClick={handleClick}
                            tafrihanSuggestion={item.tafrihanSuggestion}
                            imageLabelJson={item.imageLabelJson}
                          />
                        </SwiperSlide>
                      ))
                    )}
                  </Swiper>
                </div>
              </Row>
            </div>
          </Container>

          {/****   مجموعه های گردشگری  ******************/}
          <Container fluid className=" mt-5 mb-3">
            <Container>
              <Row className="border gx-0 rounded-3 position-relative">
                <div className="px-3">
                  <h2 className="box-title fw-bold text-primary fs-101 mb-5">
                    مجموعه های گردشگری
                  </h2>
                  {loading ? (
                    <Swiper
                      spaceBetween={10}
                      slidesPerView={"auto"}
                      className="amusement-swiper pt-3"
                    >
                      <SwiperSlide>
                        <SkeletonCardComplex />
                      </SwiperSlide>
                      <SwiperSlide>
                        <SkeletonCardComplex />
                      </SwiperSlide>
                      <SwiperSlide>
                        <SkeletonCardComplex />
                      </SwiperSlide>
                    </Swiper>
                  ) : (
                    <Swiper
                      spaceBetween={10}
                      slidesPerView={"auto"}
                      className="amusement-swiper pt-3"
                    >
                      {liveData?.amusementComplexes?.map((amusementComplex) => (
                        <SwiperSlide key={amusementComplex.id}>
                          <CardComplex
                            itemImgSrc={
                              process.env.REACT_APP_API_URL +
                              amusementComplex.imageUrl
                            }
                            itemUrl={`/p/${amusementComplex.urlName}`}
                            itemName={amusementComplex.name}
                            reserveItemCount={
                              amusementComplex.amusementServiceCount
                            }
                            // reserveItemCount={amusementComplex.amusementServices.length()}
                            itemCity={amusementComplex.amusementComplexRegions
                              ?.map((rgn) => rgn.region.name)
                              .join("، ")}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                </div>
              </Row>
            </Container>
          </Container>

          <Container fluid className="bg-light pt-4">
            <Container>
              <Row className="gx-3 ">
                {/****  انتخاب شهر ***************************************************/}
                <Col xs="12" lg="6">
                  <Card className="h-100 rounded-3 shadow-sm border bg-light-3">
                    <Card.Body className="py-1">
                      <Row className=" my-auto h-100">
                        <Col xs="auto" className="pe-0 my-auto">
                          <div className="fw-500 fs-normal mt-3">
                            شهر مورد نظرت رو انتخاب کن
                          </div>
                          <div className="fs-085 mt-2 ">
                            تا تفریحات اختصاصی همون شهر رو ببینی ...
                          </div>
                          <Button
                            variant="danger"
                            className="fs-085 mt-2 mb-2 mb-lg-0 mt-lg-3 btn-sm rounded-2"
                            onClick={() => {
                              setShowModalSelectCity(true);
                            }}
                          >
                            اتنخاب شهر <IconChevronLeft fillColor="white" />
                          </Button>
                        </Col>
                        <Col className="text-end my-auto pe-1">
                          <img
                            src={mapImage}
                            alt="map"
                            style={{ width: "110px" }}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  {showModalSelectCity && (
                    <SelectCityModal
                      showModalSelectCity={showModalSelectCity}
                      setShowModalSelectCity={setShowModalSelectCity}
                    />
                  )}
                </Col>
                <Col xs="12" lg="6" className="mt-3 mt-lg-0">
                  {/****  e-namad  ***************************************************/}
                  <div className="h-100">
                    <a
                      className="h-100"
                      referrerPolicy="origin"
                      target="_blank"
                      href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                    >
                      <Card className=" rounded-3  border bg-light-3 shadow-sm h-100 ">
                        <Card.Body className="py-2">
                          <Row className="aling-items-center justify-content-center h-100">
                            <Col className="pe-0 my-auto fs-normal">
                              <div className="">
                                این وب سایت دارای{" "}
                                <span className="fw-bold mx-1 d-inline-block">
                                  مجوز رسمی
                                </span>
                                <span>از</span>
                                <span className="fw-bold mx-1">
                                  {" "}
                                  سازمان میراث فرهنگی و گردشگری{" "}
                                </span>
                              </div>
                              <div>
                                و
                                <span className="fw-bold mx-1">
                                  وزارت صنعت و معدن
                                </span>{" "}
                                می باشد.
                              </div>
                            </Col>
                            <Col xs="auto" className="text-end my-auto px-1">
                              <img
                                alt="eNamad"
                                referrerPolicy="origin"
                                className="rounded-3 h-100 "
                                src={enamadImage}
                                style={{ cursor: "pointer", width: "70px" }}
                                id="A32132KLXam6f2jcPJyV"
                              />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>

            <Container className="pb-3">
              <Row className="gx-3">
                <Col>
                  {/**** ثبت نام تامین کنندگان  ***************************************************/}
                  <Link
                    to="https://sup.tafrihan.com/register"
                    target="_blank"
                    className="d-block"
                  >
                    <Card className="mt-3 rounded-3 border bg-light-blue shadow-sm text-black line-height-1 cursor-pointer">
                      <Card.Body className="py-3">
                        <Row>
                          <Col className="pe-0 my-auto">
                            <div className="bg-warning shadow-sm title-box-rounded py-1 ps-2 pe-2 d-inline-block fw-bold mb-2 fs-08">
                              ثبت نـام تامین کنندگان
                              <IconDoubleArrowLeft fillColor="#000" />
                            </div>
                            <div className=" fs-08">
                              <div>
                                اگر شما هم دارای مجموعه گردشگری هستید می توانید
                                هم اکنون رزرو مجموعه خود را به تفریحان بسپارید.
                              </div>
                            </div>
                          </Col>
                          <Col xs="auto" className="text-end my-auto px-0">
                            <img
                              src={suplierImage}
                              alt="map"
                              style={{ width: "95px" }}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
                {/**** ثبت نام نمایندگان  ***************************************************/}
                <Col>
                  <Link
                    to="https://agent.tafrihan.com/register"
                    target="_blank"
                    className="d-block"
                  >
                    <Card className="mt-3 rounded-3 border bg-light-blue shadow-sm text-black line-height-1">
                      <Card.Body className="py-3">
                        <Row>
                          <Col className="pe-0 my-auto">
                            <div className="bg-warning shadow-sm title-box-rounded py-1 ps-2 pe-2 d-inline-block fw-bold mb-2 fs-08">
                              ثبت نـام نـماینـدگان
                              <IconDoubleArrowLeft fillColor="#000" />
                            </div>
                            <div className=" fs-08">
                              <div>
                                فروش تفریحات و دریافت کمیسیون برای تمامی افراد
                                حقیقی و حقوقی در مجموعه تفریحان قابل انجام است.
                              </div>
                            </div>
                          </Col>
                          <Col xs="auto" className="text-end my-auto px-1">
                            <img
                              src={getMoneyImage}
                              alt="map"
                              style={{ width: "80px" }}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              </Row>
            </Container>
          </Container>
        </>
      )}
    </>
  );
}
export default HomeContent;
